var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 252,
    viewBox: "0 0 221 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -80.141,
    cy: 301.86,
    r: 301.141,
    fill: "#EF4667",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -80.1409,
    cy: 301.86,
    r: 237.918,
    fill: "#9D0E2A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -80.141,
    cy: 301.86,
    r: 182.182,
    fill: "#EF4667",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.63da9d438d58fd45d574581d1400548b.svg";
export { ForwardRef as ReactComponent };